import { type OfferingProduct } from "./offering"

export enum OfferingType {
  Pro = "pro",
  BaseSubscription = "pt_checkout",
  Upsell = "course",
  Downsell = "coaching_2025",
  UnlimitedShops = "profittree_addons",
}

export const ProductType: Record<OfferingType, string> = {
  [OfferingType.Pro]: "profittree_pro",
  [OfferingType.BaseSubscription]: "base_sub_000",
  [OfferingType.Upsell]: "1year_coaching",
  [OfferingType.Downsell]: "group_coaching",
  [OfferingType.UnlimitedShops]: "unlimited_shops",
} as const
export type ProductTypeValue = (typeof ProductType)[keyof typeof ProductType]

export const PriceTypes: Record<ProductTypeValue, string> = {
  profittree_pro: "annual",
  base_sub_000: "annual",
  "1year_coaching": "discount_1",
  group_coaching: "discount_1",
  unlimited_shops: "regular",
}

export type OfferingsByType = Partial<Record<OfferingType, OfferingProduct>>
export type Cart = Partial<Record<OfferingType, string | null>>
